import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Tracks whether a page is holding data the user has entered but not submitted,
// which recreating the page would destroy. View state — filters, pagination, the
// selected tab — is not a reason to block: discarding that is what a reset is
// for. Pages report their own state and release it when they unmount; clearing
// on navigation bounds a missed release to a single route visit instead of the
// rest of the session.
export default function useResetBlocked() {
  const [isResetBlocked, setIsResetBlocked] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setIsResetBlocked(false);
  }, [pathname]);

  return { isResetBlocked, setIsResetBlocked };
}
